module.exports = __webpack_public_path__ + "static/media/web_dev.84535a57.png";